import React from 'react';
import {inject, observer} from 'mobx-react';
import {RouteComponentProps} from 'react-router-dom';
import {UserStoreTypes} from '@/stores/user';
import {Nav,FlashTips} from '@/components';
import renderRoutes, {routeType} from '@/layouts/renderRoutes';
import {useLocalStorage, useEffectOnce, useUpdate} from 'react-use';
import ObjectType from '@/types/ObjectType';
import {EventType } from '@/components/Nav'
import useReactRouter from 'use-react-router';
import {BaseStoreTypes} from '@/stores/base';
import * as R from 'ramda';
import log from '@/utils/log';
import {DeviceStoreTypes} from '@/stores/device';

export interface PropsType {
    UserStore: UserStoreTypes;
    BaseStore: BaseStoreTypes;
    DeviceStore: DeviceStoreTypes;
    route: routeType & { routes: routeType [] };
}

type SignInProps = PropsType & RouteComponentProps;


const Home: React.FC<SignInProps> = inject('UserStore','BaseStore','DeviceStore')(observer(props => {
  
    const {route, BaseStore, UserStore, DeviceStore} = props;
  
    const [activeRoom]: any = useLocalStorage('activeRoom');
  
    const {history} = useReactRouter();
  
    const update = useUpdate();
  
    const [userInfo] = useLocalStorage('userInfo');
    
    if (!userInfo) {
      history.push('/')
      return <></>
    }
    
    let  mobile: string = (userInfo as ObjectType).mobile
  
    const handleNavOnChange = async (e: EventType) => {
  
        /* 用户下拉菜单 */
        if (e.type === 'user') {
            switch(e.key) {
                case '1':
                  log({pageId: 'P90', eventId: 'E9006',ext: ''})
                  history.push('/Home/Modify');
                    break
                case '2':
                  log({pageId: 'P90', eventId: 'E9007',ext: ''})
                  UserStore.OrderStore.setSelected(1);
                    history.push('/Home/Order');
                    break
                case '3' :
                  log({pageId: 'P90', eventId: 'E9008',ext: ''})
                  UserStore.OrderStore.setSelected(0);
                    history.push('/Home/Order');
                    break
                case '4' :
                  log({pageId: 'P90', eventId: 'E9004',ext: ''})
                  window.localStorage.removeItem('userInfo')
                  history.push('/');
                    break
                default : return
            }
        }
    
        /* 站点选择 */
        if (e.type === 'room') {
          log({pageId: 'P91', eventId: 'E9101',ext: e.key})
          const status= await BaseStore.RoomStore.checkRoomStatus(Number(e.key));
          
          if (status) {
            DeviceStore.DeviceBaseStore.setCids([])
            DeviceStore.DeviceBaseStore.setDeviceList([])
            UserStore.GroupStore.setGroupId(-1)
            DeviceStore.DeviceBaseStore.setDeviceInfoInit();
            await DeviceStore.DeviceBaseStore.getDeviceInfo()
            update()
          }
        }
    
    
        /* 导航切换 */
        if (e.type === 'menu') {
      
            switch(e.key) {
                case '1' :
                  log({pageId: 'P90', eventId: 'E9001',ext: ''})
                  history.push('/Home/CloudPhone');
                    break
                case '2' :
                  log({pageId: 'P90', eventId: 'E9002',ext: ''})
                  history.push('/Home/Buy');
                    break
                case '3' :
                  log({pageId: 'P90', eventId: 'E9005',ext: ''})
                  history.push('/Home/Vas');
                    break
                default:  return
            }
      
        }
    
    }
  
    useEffectOnce(() => {
        (async () => {
            await BaseStore.RoomStore.getRoomList();
            if (R.type(activeRoom) === 'Object') {
                await BaseStore.RoomStore.checkRoomStatus(Number(activeRoom.id));
            }
        })()
    })
  
    return (
    <>
      <FlashTips
        show={UserStore.FlashStore.show}
        close={UserStore.FlashStore.close}
        newWindow={UserStore.FlashStore.newWindow}
      />
      <Nav activeData={BaseStore.RoomStore.activeRoom} dataSource={BaseStore.RoomStore.roomList} userName={mobile} onChange={handleNavOnChange}/>
      {renderRoutes(route.routes)}
    </>
    )
  
}))

export default Home;
